import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withSizes } from 'react-sizes';

import { fetchHomepage } from 'client/ducks/homepage/actions';
import { getHomepage, isLoading } from 'client/ducks/homepage/selectors';
import { State } from 'client/store';
import { mapSizesToProps } from 'client/helpers/sizes';

import NotFoundPage, { DispatchProps, StateProps } from './not-found';

function mapStateToProps(state: State): StateProps {
    return {
        data: getHomepage(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchHomepage
};

export default compose<ComponentType>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    withSizes(mapSizesToProps)
)(NotFoundPage) as any;
